import type {Updater, Writable} from 'svelte/store';
import {writable} from 'svelte/store';
import {isEqual} from 'lodash-es';

export function distinctStore<T>(initialValue: T): Writable<T> {
    const { subscribe, set: originalSet} = writable(initialValue);
    let currentValue = initialValue;

    const set = (newValue: T) => {
        if (!isEqual(currentValue, newValue)) {
            currentValue = newValue;
            originalSet(newValue);
        }
    }

    return {
        subscribe,
        set,
        update: (updater: Updater<T>) => {
            const newValue = updater(currentValue);
            set(newValue); // use our custom set
        }
    };
}